<template>
  <v-app id="login">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>{{ $t('title') }}</v-toolbar-title>
                <v-spacer/>
                <locale-switcher light/>
              </v-toolbar>
              <v-card-text>
                <h3 class="text-xs-center my-4">{{ $t('header') }}</h3>
                <p>{{ $t('hint') }}</p>
                <v-form @submit.prevent="doSignIn">
                  <v-text-field v-model="username" id="username" prepend-icon="person" name="login"
                                :label="$t('labels.login')" type="text" @input="onCredentialsChange"/>
                  <v-text-field v-model="password" id="password" prepend-icon="lock" name="password"
                                :label="$t('labels.password')" type="password" :error="isError"
                                :error-messages="errorMessage" @input="onCredentialsChange"/>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="doSignIn" :loading="loading" :disabled="loading">
                  {{ $t('actions.login') }}
                  <template #loader>
                    <span class="loader">
                      <v-icon light>cached</v-icon>
                    </span>
                  </template>
                </v-btn>
              </v-card-actions>
            </v-card>
            <!-- <v-alert v-model="isError" type="error">{{ errorMessage }}</v-alert> -->
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import LocaleSwitcher from "@/components/LocaleSwitcher";

export default {
  components: {
    LocaleSwitcher
  },
  data: () => ({
    username: '',
    password: '',

    isError: false,
    errorMessage: '',

    loading: false
  }),
  methods: {
    doSignIn() {
      this.errorMessage = ''
      this.isError = false

      this.loading = true

      setTimeout(() => {
        this.$store
          .dispatch('signIn', { username: this.username, password: this.password })
          .then((result) => {
            if (result.success) {
              this.$cookie.set('x-user-id', result.user.id, { expires: '45m' })

              this.$events.$emit('authenticated', result.user)
              // this.$store.dispatch('getUserInfo', result.user)
            } else {
              this.errorMessage = `${result.message || 'Произошла ошибка, попробуйте повторить позднее.'} [78L]`
              this.isError = true
            }

            this.loading = false
          })
          .catch((e) => {
            const trace = e.stack
            this.errorMessage = `${e.message} [85L] : ${trace}`
            this.isError = true

            this.loading = false
          })
      }, 1200)
    },
    onCredentialsChange() {
      this.isError = false
      this.errorMessage = ''
    }
  }
}
</script>

<style scoped>
.loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

<i18n>
{
  "ru": {
    "title": "Авторизация",
    "header": "Планирование и учет педагогической нагрузки",
    "hint": "Для входа, пожалуйста, используйте свой логин/пароль от системы Платонус.",
    "labels": {
      "login": "Имя пользователя",
      "password": "Пароль"
    },
    "actions": {
      "login": "Вход"
    }
  },
  "kz": {
    "title": "Авторизация",
    "header": "Оқу жүктемесін жоспарлау және есепке алу",
    "hint": "Кіру үшін Platonus жүйесіндегі логин / парольді қолданыңыз.",
    "labels": {
      "login": "Имя пользователя",
      "password": "Пароль"
    },
    "actions": {
      "login": "Кіру"
    }
  }
}
</i18n>
